import axios from "axios";
import { takeLatest, call, put } from "redux-saga/effects";
import { API_BASE_URI } from "../ApiCall";
import {
  ServiceRequestActionTypes,
} from "./ServiceRequest.type";

function* fetchAllServiceRequests(action: any): any {
  try {
    const res = yield call(
      axios.get,
      API_BASE_URI + "/service-request",
      { params: action.payload }
    );
    yield put({
      type: ServiceRequestActionTypes.FETCH_ALL_SERVICE_REQUEST_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    yield put({
      type: ServiceRequestActionTypes.FETCH_ALL_SERVICE_REQUEST_FAILURE,
    });
  }
}

function* watcherFetchAllServiceRequests(): any {
  yield takeLatest(
    ServiceRequestActionTypes.FETCH_ALL_SERVICE_REQUEST,
    fetchAllServiceRequests
  );
}

function* fetchOneServiceRequests(action: any): any {
  try {
    const res = yield call(
      axios.get,
      API_BASE_URI + "/service-request/" + action.payload
    );
    yield put({
      type: ServiceRequestActionTypes.FETCH_ONE_SERVICE_REQUEST_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    yield put({
      type: ServiceRequestActionTypes.FETCH_ONE_SERVICE_REQUEST_FAILURE,
    });
  }
}

function* watcherFetchOneServiceRequests(): any {
  yield takeLatest(
    ServiceRequestActionTypes.FETCH_ONE_SERVICE_REQUEST,
    fetchOneServiceRequests
  );
}

export { watcherFetchAllServiceRequests, watcherFetchOneServiceRequests };
